export default "__VITE_ASSET__BxSMw0V9__"